{
  "slug": "kvq",
  "status": "live",
  "isDemoContent": false,
  "name": "Детейлинг-студия «KVQ»",
  "tagline": "Мойка, полировка и защита кузова — бережно и в срок",
  "about": "Работаем с 2016 года. Один универсальный бокс с правильным светом. Перед работой осматриваем кузов при вас и называем точную стоимость: если по ходу находим что-то ещё, сначала согласуем.",
  "address": "ул. Промышленная, 14, стр. 2",
  "addressNote": "Въезд со стороны двора, ориентир — синие ворота. Своя парковка на 6 мест.",
  "phone": "+74951234567",
  "phoneDisplay": "+7 (495) 123-45-67",
  "accent": {
    "light": "#2563EB",
    "dark": "#5B9CFF"
  },
  "timezone": "Europe/Moscow",
  "workingHours": [
    {
      "weekday": 1,
      "opensAt": "09:00",
      "closesAt": "20:00"
    },
    {
      "weekday": 2,
      "opensAt": "09:00",
      "closesAt": "20:00"
    },
    {
      "weekday": 3,
      "opensAt": "09:00",
      "closesAt": "20:00"
    },
    {
      "weekday": 4,
      "opensAt": "09:00",
      "closesAt": "20:00"
    },
    {
      "weekday": 5,
      "opensAt": "09:00",
      "closesAt": "20:00"
    },
    {
      "weekday": 6,
      "opensAt": "10:00",
      "closesAt": "17:00"
    }
  ],
  "resources": [
    {
      "name": "Бокс 1",
      "kind": "bay",
      "sortOrder": 10
    }
  ],
  "infoCards": [],
  "services": [
    {
      "slug": "kompleksnaya-moyka",
      "name": "Комплексная мойка",
      "summary": "Двухфазная мойка кузова, колёс и порогов, уборка салона пылесосом.",
      "priceFromRub": 3500,
      "durationMinMinutes": 90,
      "durationMaxMinutes": 120,
      "allowOvernight": false,
      "bufferMinutes": 15,
      "sortOrder": 10,
      "includes": [
        "Бесконтактная мойка кузова в две фазы",
        "Мойка дисков и колёсных арок",
        "Чистка порогов и дверных проёмов",
        "Уборка салона пылесосом",
        "Протирка стёкол изнутри"
      ],
      "notes": [
        "Сильные загрязнения после бездорожья считаются отдельно — скажем на приёмке."
      ],
      "resources": [
        "Бокс 1"
      ]
    },
    {
      "slug": "detejling-salona",
      "name": "Детейлинг салона",
      "summary": "Глубокая чистка сидений, пластика, ковров и потолка с защитой кожи.",
      "priceFromRub": 9500,
      "durationMinMinutes": 240,
      "durationMaxMinutes": 360,
      "allowOvernight": false,
      "bufferMinutes": 30,
      "sortOrder": 20,
      "includes": [
        "Чистка сидений, ковров и потолка",
        "Очистка и защита пластика",
        "Чистка и кондиционер кожи",
        "Обработка дверных карт и багажника",
        "Озонирование салона"
      ],
      "notes": [
        "Застарелые пятна могут не уйти полностью — предупредим заранее."
      ],
      "resources": [
        "Бокс 1"
      ]
    },
    {
      "slug": "vosstanovitelnaya-polirovka",
      "name": "Восстановительная полировка",
      "summary": "Снимаем мелкие царапины и голограммы, возвращаем лаку глубину и блеск.",
      "priceFromRub": 14000,
      "durationMinMinutes": 360,
      "durationMaxMinutes": 480,
      "allowOvernight": false,
      "bufferMinutes": 30,
      "sortOrder": 30,
      "includes": [
        "Мойка и очистка кузова глиной",
        "Замер толщины лакокрасочного покрытия",
        "Полировка в два этапа",
        "Финишная защитная обработка"
      ],
      "notes": [
        "Глубокие царапины до грунта полировкой не убираются — подскажем, что делать."
      ],
      "resources": [
        "Бокс 1"
      ]
    },
    {
      "slug": "nanokeramika",
      "name": "Нанокерамика кузова",
      "summary": "Твёрдое защитное покрытие: блеск, гидрофоб и защита лака до двух лет.",
      "priceFromRub": 22000,
      "durationMinMinutes": 480,
      "durationMaxMinutes": 600,
      "allowOvernight": false,
      "bufferMinutes": 60,
      "sortOrder": 40,
      "includes": [
        "Подготовка и обезжиривание кузова",
        "Нанесение двух слоёв состава",
        "Инфракрасная сушка",
        "Контроль покрытия под лампой"
      ],
      "notes": [
        "Перед нанесением нужна полировка — считается отдельно.",
        "Первые сутки машину нельзя мыть."
      ],
      "resources": [
        "Бокс 1"
      ]
    },
    {
      "slug": "antidozhd",
      "name": "Антидождь на стёкла",
      "summary": "Водоотталкивающее покрытие лобового и боковых стёкол.",
      "priceFromRub": 2000,
      "durationMinMinutes": 30,
      "durationMaxMinutes": 45,
      "allowOvernight": false,
      "bufferMinutes": 10,
      "sortOrder": 50,
      "includes": [
        "Очистка стёкол",
        "Нанесение состава",
        "Полировка до прозрачности"
      ],
      "notes": [
        "Держится до трёх месяцев при обычной эксплуатации."
      ],
      "resources": [
        "Бокс 1"
      ]
    },
    {
      "slug": "bronplenka-fary",
      "name": "Бронеплёнка на фары",
      "summary": "Прозрачная полиуретановая плёнка защищает фары от сколов и помутнения.",
      "priceFromRub": 6500,
      "durationMinMinutes": 120,
      "durationMaxMinutes": 180,
      "allowOvernight": false,
      "bufferMinutes": 20,
      "sortOrder": 60,
      "includes": [
        "Мойка и обезжиривание фар",
        "Раскрой плёнки по лекалу",
        "Оклейка и прогрев",
        "Контроль кромок"
      ],
      "notes": [
        "Плёнка не желтеет; гарантия на оклейку — год."
      ],
      "resources": [
        "Бокс 1"
      ]
    }
  ]
}
